<template>
  <div class="login" v-if="isshow">
    <div class="login_content animated zoomIn">
      <img src="../assets/images/login3.png" class="logoimg animated fadeInDown" style="  width: 712px;  height: auto;" />
      <div class="single_page">
        <el-tabs v-model="activeName"  @tab-click="handleClick">
          <el-tab-pane label="扫码登录" name="first">
            <div id="qroode" class="qrconde" ref="qrCodeDiv" v-if="imageDta == ''" style="margin: 75px;"></div>
          </el-tab-pane>
          <el-tab-pane label="密码登录" name="second">
            <el-form ref="loginForm" :rules="rules" :model="loginForm">
                <el-form-item prop="username" class="form_item">
                  <p>账号</p>
                  <el-input 
                    placeholder="请输入用户名"
                    v-model="loginForm.username"
                    @focus="getfocus(1)"
                    v-on:keyup.enter.native="onSubmit('loginForm')"
                    autocomplete="off">					
                  </el-input>
                </el-form-item>
                
                <el-form-item prop="password" class="form_item">
                  <p>密码</p>
                  <el-input
                    placeholder="请输入密码"
                    type="password"
                    v-model="loginForm.password"
                    :show-password="true"
                    @focus="getfocus(2)"
                    v-on:keyup.enter.native="onSubmit('loginForm')"
                    autocomplete="off">
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>
                </el-form-item>
                <el-form-item>
                  <div class="login-btn" @click="onSubmit('loginForm')" style=" margin:10px 0 0;">
                    登录
                  </div>
                </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="footer">软件设计单位：杭州星火云科技有限公司</div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import Cookies from 'js-cookie';
// import { encrypt, decrypt } from '@/util/jsencrypt'
import md5 from 'js-md5';
import QRCode from "qrcodejs2"
import html2canvas from "html2canvas"
import axios from 'axios'
import qs from 'qs'

export default {
  name: "Login",
  data() {
    return {
      activeName: 'second',
      loginForm: {
        username: "",
        password: ""
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      identifyCodes: "1234567890",
			identifyCode:'',
      taptime: false,
      loading: false,
      dialogFormVisible:false,
	  focusval:0,
      formPop:{
        password: '',
        newPassword:'',
        newPassword2:''
      },
      rules2:{
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        newPassword: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        newPassword2: [{ required: true, message: "请确认新密码", trigger: "blur" }],
      },
	    isshow:true,
      imageDta:'',
      imgData:"",
      ewm_data:0,
      code_time:0,
      token_time:0,
    };
  },
  components: {
  },
  mounted(){	
	},
	created() {	
    // var date = this.getDate(new Date());
    // console.log(date)
    clearTimeout(this.code_time)
    clearTimeout(this.token_time)
    this.getCookie();
	},
    // computed: {
    //     ...mapGetters([
    //         'loading'
    //     ])
    // },
  methods: {
    ...mapMutations({
      setUserdata: "SET_USERDATA"
    }),
    getCookie() {
      const username = Cookies.get('username')
      const password = Cookies.get('password')
      const rememberMe = Cookies.get('rememberMe')
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : password,
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      }
    },
    onSubmit(form) {
      this.$refs[form].validate(async valid => {
        if (valid) {
          if (this.loginForm.rememberMe) {
            Cookies.set('username', this.loginForm.username, { expires: 30 })
            Cookies.set('password', this.loginForm.password, { expires: 30 })
            Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 30 })
          } else {
            Cookies.remove('username')
            Cookies.remove('password')
            Cookies.remove('rememberMe')
          }
          this.toHome()
        } else {
          return false;
        }
      });
    },
    getfocus(val){
      this.focusval=val
    },
    checkpassword(v){
      var numasc = 0;
      var charasc = 0;
      var otherasc = 0;
      if(0==v.length){
        return "密码不能为空";
      }else if(v.length < 6){
        return "密码至少6个字符";
      }else{
        for (var i = 0; i < v.length; i++) {
          var asciiNumber = v.substr(i, 1).charCodeAt();
          if (asciiNumber >= 48 && asciiNumber <= 57) {
            numasc += 1; //数字
          }
          if ((asciiNumber >= 65 && asciiNumber <= 90)||(asciiNumber >= 97 && asciiNumber <= 122)) {
            charasc += 1; // 字母
          }
          // if ((asciiNumber >= 33 && asciiNumber <= 47)||(asciiNumber >= 58 && asciiNumber <= 64)||(asciiNumber >= 91 && asciiNumber <= 96)||(asciiNumber >= 123 && asciiNumber <= 126)) {
          //   otherasc += 1;//特殊字符
          // }
        }
        if(0==numasc)  {
          return "密码必须含有数字";
        }else if(0==charasc){
          return "密码必须含有字母";
        }else{                
          return true;            
        }  
        // else if(0==otherasc){
        //   return "密码必须含有特殊字符";            
        // }      
      }
    },
    async toHome(){
      this.loading = true;
      let time = new Date().getTime();
      if (!this.taptime) {
        this.taptime = time;
      } else if (time - this.taptime < 1000) {
        return false;
      }
      this.taptime = new Date().getTime();
      axios({
          method: 'post',
          url: `https://xxswj.hzxhykj.com:9086/login/recordLogin`,
          data:{
              dm:this.loginForm.username,
              mm:md5(this.loginForm.password),
          },
          headers: { 
              "Content-Type": "application/json"
          },
      }).then(res => {
          console.log(res,809)
          this.loading = false
          if(res.data.code == 0 && res.data.data){
            sessionStorage.clear();
            let userdata = res.data.data;
           console.log(111111111111111,userdata)
            userdata.time = new Date().getTime() + 1000 * 60 * 60 * 2;
            userdata.baseUrl = `https://xxswj.hzxhykj.com:9086`
            
            sessionStorage.setItem("userdata", JSON.stringify(userdata));
            this.setUserdata(userdata);
            localStorage.removeItem('menu')
            setTimeout(() => {
              this.loading = false;
              this.$router.push("/index");
            }, 500);   
          }else{
              if(res.data.msg){
                  this.$message.error(res.data.msg)
              }else{
                  this.$message({
                      message: '登录失败，请联系管理员',
                      type: 'error'
                  }); 
              }
          }
      }).catch(error => {
        console.log(error,226)
          setTimeout(() => {
            this.$alert("登录账户不存在或用户名、密码错误！", "信息提示", {
              type: "error",
              callback: () => {
                this.loginForm = {};
              }
            });
            this.loading = false;
          }, 500);
      })
    },
    getToken(){
      axios({
          method: 'post',
          url: `https://xxswj.hzxhykj.com:9086/login/setTokenSerial`,
          data:{},
          headers: { 
              "Content-Type": "application/json"
          },
      }).then(res => {
        console.log(res,248)
          if(res.data.code == 0 ){
              let msg = res.data.msg;
              var date = this.getDate(new Date());
              console.log(res)
              console.log(date)
              if(msg){
                this.rqcode(res)
                this.createPicture()    //转换图片
              }else{ 
                this.rqcode('123456789')
                this.createPicture()    //转换图片
              }    
              this.token_time = setTimeout(()=> {
                this.clear_qrcode()
                this.getToken()
            }, 60000)    
              this.ewm_data = res
              this.ewm_is()
          }else{
              if(res.data.msg){
                  this.$message.error(res.data.msg)
              }
          }
      }).catch(error => {
          this.$message.error(error);
      })
      
    },
    async handleClick(tab, event) {
      clearTimeout(this.code_time)
      clearTimeout(this.token_time)
      if(this.activeName == 'first'){
        this.imageDta = ""
        this.getToken()
      }else{
        this.clear_qrcode()
      }
    },
    rqcode(res){
      new QRCode(this.$refs.qrCodeDiv,{
        text:res, 
        //text为转换为二维码的文本，可以是所有东西：图片、文本、电话、链接等等
        width:190,   //生成二维码的宽度
        height:190,   //生成二维码的高度
        colorDark:'#000',   // 二维码颜色
        colorLight:'#fff',  //二维码背景颜色
        // correctLevel:QRCode.correctLevel.L,   //容错率 ，L/M/H
      })
    },
    createPicture(){  //二维码转为图片    ---前端
        this.imgData = ""
        html2canvas(this.$refs.qrCodeDiv, {     //设置图片的背景颜色、宽度、高度
            backgroundColor: null,
            width: 190,
            height: 190
        }).then(canvas => {
            var imgData = canvas.toDataURL('image/jpeg')  //这里转为图片方式
            this.imgData = imgData
        })
    },
    clear_qrcode(){  //清除二维码 ---前端
      this.imageDta = "加载中..."
        this.imgData = ""
        this.ewm_data = 0
    },
    ewm_is() {
      axios({
          method: 'post',
          url: `https://xxswj.hzxhykj.com:9086/login/getToken`,
          data:{},
          headers: { 
              "Content-Type": "application/json"
          },
      }).then(res => {
          if(res.data.code == 0 ){
              let res = res.data.data
              if(res){
                var arr = res 
                if (arr[0].token === this.ewm_data) {
                    var mm = escape(data[0].mm);
                    this.loginForm.username = arr[0].dm
                    this.loginForm.password = mm
                    this.toHome()
                }
              }
              this.code_time = setTimeout(()=> {
                  this.ewm_is()
              }, 1000)
          }else{
              if(res.data.msg){
                  this.$message.error(res.data.msg)
              }
          }
      }).catch(error => {
          this.$message.error(error);
      })
    }
  },
  
};
</script>

<style scoped>
.login {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: url(../assets/images/bg.png) no-repeat top center;
  background-size: 100% 55.56%;
  position: relative;
}

.login_content {
  width: 800px;
  position: absolute;
  top: 11.5vh;
  left: 50%;
  transform: translateX(-50%);
}
.logoimg {
  width:auto;
	height:87px;
  margin:0 44px;
}
.single_page {
  width: 440px;
  padding-left: 360px;
  height: 480px;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 0px rgb(1 42 75 / 15%);
  margin: 5vh auto;
  background:#ffffff url(../assets/images/logo-left.png) no-repeat left center;
  background-size: 360px 100%;
}
.single_page >>> .el-tabs{ margin:0 50px; padding-top: 30px;}
.single_page >>> .el-tabs .el-tabs__nav{width: 100%;}
.single_page >>> .el-tabs .el-tabs__active-bar,.single_page >>> .el-tabs .el-tabs__item{ width: 50% !important;padding:0;text-align: center;}
.single_page >>> .el-tabs .el-tabs__item{font-family: Microsoft YaHei;color: #808080;font-size: 16px;}
.single_page >>> .el-tabs .el-tabs__item.is-active{color: #1493FA;font-weight: bold;}
.login >>> .el-form-item {
  width: 100%;
  z-index: 5;
  margin: 18px 0 0;
}  
.login >>> .el-form-item:last-child { margin:0 0 0;} 
.login p {
  color: #000;
  font-size: 14px;
  font-weight: bold;
}
.login >>> .el-input__inner {
	width: 100%;
	height: 40px;
	color:#000;
	text-indent:15px;
	background: rgba(9,40,106,0);
	/* padding: 0px 53px; */	
	border: 1px solid #ddd;
	border-radius: 2px;
  padding: 0;
}
.login >>> .el-input__inner:focus{
	background: #EEE;
}
.yzm >>> .el-input__inner {
	width: 180px;
}

.login-btn{
	display: block; 
	text-align: center; 
	cursor: pointer;
	line-height: 50px;
	width: 100%;
	height: 50px;
	border:none;
	border: none;
	background: #1493fa;
  color: #fff;
	border-radius: 2px;	
}
.yzm-img{
  position: absolute;
  right: 0;
  top:0;
}
.login >>> .el-input__prefix,.login >>>  .el-input__suffix {
    position: absolute;
    top: 5px;
	left:5px;
    -webkit-transition: all .3s;
    height: 100%;
    color: #C0C4CC;
    text-align: center;
}
.login >>> .el-input__prefix span img{	
	width:20px;
	height:20px;
	padding-left:13px;;
}

.login >>> .el-input__clear{
	position: absolute;
	right:10px;
}
.login >>> .el-input__prefix span{
	display:inline-block;
	overflow:hidden;
}
.login >>> .active img{
	filter: drop-shadow(white 80px 0);
	transform: translateX(-80px);
}

.footer{text-align: center; position: fixed; bottom: 50px; width: 100%; color: #B3B3B3; font-size: 12px;}
</style>